import accountBase from './components/accountBase';
import securitySetting from './components/securitySetting';
import customSetting from './components/customSetting';
export default {
  name: 'setting',
  components: {
    accountBase,
    securitySetting,
    customSetting
  },
  data() {
    return {};
  }
};